import { isCODWithoutPartialPayment } from "../../utils/order.util";

// Founder sheet, new sh0p rate incl. GST %. No flat ₹1 on these.
const serviceChargeMapping = {
  cc: (deliveryOption) => (deliveryOption?.key === "international" ? 4.99 : 3.2),
  dc: (price, deliveryOption) =>
    deliveryOption?.key === "international" ? 4.99 : price > 2000 ? 2.28 : 2,
  upi: 2.18,
  app: 2.98,
  nb: 2.93,
  bnpl: 5.0,
};

const truncateTo2Decimals = (num) => {
  if (num == null) return null;
  return Math.floor(num * 100) / 100;
};

const getApplicableProcessingFee = (processingFee, storePaysProcessingFee) => {
  if (storePaysProcessingFee) {
    return 0;
  }

  return processingFee;
};

const getPrice = (deliveryOption, cart, paymentMode = null, storePaysProcessingFee = false) => {
  const partialPaymentPercentage = deliveryOption?.partialPaymentPercentage;
  let calculatedPrice = 0;
  let shippingFeeApplied = false;
  let shippingFee = deliveryOption?.shippingCharge;
  let discountedAmount = cart?.discountedAmount;
  let couponId, couponCode;
  let partialPaymentPrice = null;

  if (discountedAmount) {
    couponId = cart.couponId;
    couponCode = cart.couponCode;
  }
  const actualShippingFee = cart.shippingFee;
  const shippingFeeCap = Number.isInteger(cart.shippingFeeCap)
    ? cart.shippingFeeCap
    : Number.MAX_SAFE_INTEGER;
  for (const product of cart.products) {
    const productQuantity = product.quantity ? product.quantity : 1;
    calculatedPrice += product.salePrice * productQuantity;
  }

  let priceWithoutFees = calculatedPrice;
  if (discountedAmount) {
    calculatedPrice = priceWithoutFees - discountedAmount;
  }

  if (calculatedPrice < shippingFeeCap) {
    calculatedPrice += shippingFee ? shippingFee : 0;
    shippingFeeApplied = true;
  } else {
    shippingFee = 0;
  }

  const productTotalPrice = calculatedPrice;

  let processingFee = 0;
  if (isCODWithoutPartialPayment(deliveryOption)) {
    processingFee = 0;
  } else if (paymentMode === "dc") {
    processingFee = Number(
      (
        calculatedPrice *
        (serviceChargeMapping[paymentMode](calculatedPrice, deliveryOption) / 100)
      ).toFixed(2),
    );
  } else if (paymentMode === "cc") {
    processingFee = Number(
      (calculatedPrice * (serviceChargeMapping[paymentMode](deliveryOption) / 100)).toFixed(2),
    );
  } else if (paymentMode) {
    const serviceCharge = serviceChargeMapping[paymentMode];

    if (typeof serviceCharge === "function") {
      processingFee = Number((calculatedPrice * (serviceCharge(calculatedPrice) / 100)).toFixed(2));
    } else {
      processingFee = Number((calculatedPrice * (serviceCharge / 100)).toFixed(2));
    }
  } else {
    processingFee = Number((calculatedPrice * 0.02).toFixed(2));
  }

  if (isCODWithoutPartialPayment(deliveryOption) || !paymentMode || paymentMode === "bnpl") {
    processingFee += 1;
  }

  const pricewithShipping = calculatedPrice;

  calculatedPrice += getApplicableProcessingFee(processingFee, storePaysProcessingFee);

  if (partialPaymentPercentage) {
    partialPaymentPrice =
      pricewithShipping * (partialPaymentPercentage / 100) +
      getApplicableProcessingFee(processingFee, storePaysProcessingFee);
  }

  calculatedPrice = calculatedPrice != 0 ? calculatedPrice.toFixed(2) : calculatedPrice;

  return {
    productTotalPrice: productTotalPrice,
    total: calculatedPrice,
    shippingFee,
    shippingFeeCap,
    actualShippingFee,
    paymentProcessingFee: processingFee,
    shippingFeeApplied,
    priceWithoutFees,
    couponId,
    couponCode,
    partialPaymentPrice,
  };
};

export { getPrice, truncateTo2Decimals };

/*
 * Old buyer fee (Cashfree-era). Not what this file charges anymore.
 * Restore this if checkout is switched back. Flat ₹1 was added after every %.
 * No GST line on these %. Buyer pays unless the store pays the fee itself.
 *
 *   UPI base ≤ ₹600                          2.18% + ₹1
 *   UPI base > ₹600, cohort includes 5       2.00% + ₹1
 *   UPI base > ₹600, no cohort 5             1.75% + ₹1
 *   Netbanking (all banks)                   2.93% + ₹1
 *   Debit domestic ≤ ₹2,000                  2.00% + ₹1
 *   Debit domestic > ₹2,000                  2.28% + ₹1
 *   Debit, international delivery            4.99% + ₹1
 *   Credit domestic                          3.03% + ₹1
 *   Credit, international delivery           4.99% + ₹1
 *   Wallets                                  2.98% + ₹1
 *   Pay later                                5.00% + ₹1
 *   No method chosen                         2% + ₹1
 *   Full COD, no partial                     ₹1
 */
